import * as contactActions from "@rentiohq/shared-frontend/dist/redux/contact/contact.actions";
import * as contactSelectors from "@rentiohq/shared-frontend/dist/redux/contact/contact.selectors";
import { getName } from "@rentiohq/shared-frontend/dist/redux/contact/contact.utils";
import { IPartialRootState } from "@rentiohq/shared-frontend/dist/redux/types";
import { IAccount } from "@rentiohq/shared-frontend/dist/types/auth.types";
import { IContact } from "@rentiohq/shared-frontend/dist/types/contact.types";
import { formatPhone } from "@rentiohq/shared-frontend/dist/utils/phone/phone.utils";
import { EAssets } from "@rentiohq/web-shared-next/dist/assets";
import {
  Box,
  Icon,
  IMenuAction,
  Menu,
  SpinningLoader,
  Stack,
  Typography,
} from "@rentiohq/web-shared-next/dist/ui-components";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ECaptionVariant } from "../../types";
import { AccountListItemStyles } from "./AccountListItem.styles";

export interface IProps {
  account: IAccount;
  getActions?: (params: { accountIds: number[] }) => IMenuAction[];
  isLoading?: boolean;
  getSubtitle?: (
    accountIds: number[],
    contact?: IContact,
  ) =>
    | {
        subTitle: React.ReactNode | undefined;
        subTitleColor?: ECaptionVariant;
      }
    | undefined;
}

export const AccountListItem = ({
  account,
  getSubtitle,
  getActions,
  isLoading,
}: IProps) => {
  const dispatch = useDispatch();

  const accountDetails =
    useSelector((state: IPartialRootState) =>
      contactSelectors.getContactsByIds(state, [account.id]),
    ) || [];

  React.useEffect(() => {
    dispatch(
      contactActions.getContactsByAccountIds.actions.start({
        accountIds: [account.id],
      }),
    );
  }, [account.id]);

  const { subTitle = "", subTitleColor = ECaptionVariant.Default } =
    getSubtitle?.([account.id]) || {};

  const fetchedContact = accountDetails[0];

  const contactInfo = `${formatPhone(
    fetchedContact?.phone,
  )} | ${fetchedContact?.email}`;

  const sx = AccountListItemStyles(subTitleColor);

  // Will be used later

  // const handleEditContact = () => console.log({ account });

  // const handleViewContact = () => navigate(`/contacts/${account.id}`);

  const actions = [
    ...(getActions?.({ accountIds: [account.id] }) || []),
    // {
    //   label: "contact.edit_contact",
    //   icon: EAssets.PencilIcon,
    //   onClick: handleEditContact,
    // },
    // {
    //   label: "contact.view_contact.action",
    //   icon: EAssets.SingleNeutralIcon,
    //   onClick: handleViewContact,
    // },
  ];

  const iconSource = !!account.company
    ? EAssets.SuitCaseIcon
    : EAssets.UserOutlinedIcon;

  const renderMenu = () => {
    if (actions?.length === 0) {
      return;
    }

    if (isLoading || !accountDetails) {
      return <SpinningLoader />;
    }

    return <Menu actions={actions} />;
  };

  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Stack
        direction="row"
        alignItems="center"
        gap={1}
        sx={sx.content.accountItem}
      >
        {iconSource && <Icon path={iconSource} width="24px" height="24px" />}
        <Box>
          <Typography variant="subtitle1" lineHeight="16px">
            {getName(account)}
          </Typography>
          <Typography variant="subtitle1" sx={sx.content.subtitle}>
            {subTitle || contactInfo}
          </Typography>
        </Box>
      </Stack>
      {renderMenu()}
    </Stack>
  );
};
